<template>
  <ion-page>
    <master-layout pageTitle="افزودن خودروی جدید">
      <ion-card>
        <ion-card-content>
          <Loading :is="!loaded" v-if="!loaded"></Loading>
          <div v-if="loaded">
            <AjaxForm route="car/add" :callback="addCarCallback">
            <input type="hidden" readonly name="customer_id" :value="id">
              <div class="h6">مشتری : {{customer.fullname}}</div>
            <div class="mt-2">
              <label>عنوان خودرو</label>
              <input class="form-control" type="text" name="title">
            </div>
            <div class="mt-2">
              <label>تیپ خودرو</label>
              <ali-ajax-select route="app/GetTypeForSelect" title="تیپ خودرو" itemTitle="title" name="type_id" desc="جستجو تیپ خودرو" itemId="_id"></ali-ajax-select>
            </div>
            <div class="mt-2">
              <label>سال ساخت</label>
              <input class="form-control" name="produce_year">
            </div>
            <div class="mt-2">
              <label>کیلومتر فعلی خودرو</label>
              <input type="text" name="current_km" class="only_number form-control">
            </div>
              <div>
                <label>پلاک خودرو</label>
                <div class="plaque">
                  <div class="first">
                    <div class="flag green"></div>
                    <div class="flag white"></div>
                    <div class="flag red"></div>
                    <div>I.R.</div>
                    <div>IRAN</div>
                  </div>
                  <div class="second">
                    <div>
                      <input name="two_digit" maxlength="2" minlength="2" placeholder="--" type="text" class="p-input">
                    </div>
                    <div class="select-div">
                      <select class="form-control" name="alphabet">
                        <option v-for="(item,index) in plaqueAlphabet" :key="index" :value="item">{{item}}</option>
                      </select>
                    </div>
                    <div>
                      <input name="five_digit" maxlength="3" minlength="3" placeholder="---" type="text" class="p-input">
                    </div>
                  </div>
                  <div class="third">
                    <div>ایران</div>
                    <input name="ir_code" type="tel" class="two_number_input" placeholder="--" maxlength="2" minlength="2">
                  </div>
                </div>
              </div>
            <div class="">
              <button class="btn btn-success btn-block btn-lg" type="submit">افزودن خودرو</button>
            </div>
            </AjaxForm>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue';
import {mapActions} from "vuex";
import {showSystemNoti} from "@/shared/helper";
import AliSelect from "@/components/aliSelect";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    IonPage,
    AliSelect,
    AliAjaxSelect,
    AjaxForm
  },
  data()
  {
    return {
      id : null,
      customer : null,
      plaqueAlphabet : [
        'الف','ب','پ','ت','ث','ج','د','ز','ژ','س','ش','ص','ط','ع','ف',
        'ق','ک','ل','م','ن','و','ه','ی'
      ],
      loaded:false
    }
  },
  async created()
  {
    this.id = this.$route.params.id;
    const c = await this.getCustomer({id : this.id});
    console.log(c.customer)
    if (c.ok)
    {
      this.customer = c.customer;
      this.loaded = true
    }

  },
  methods: {
    ...mapActions("customer", {
      getCustomer: 'getCustomer'
    }),
    addCarCallback(result){
      if (!result.ok){
        showSystemNoti('danger',result.error);
      }
      else
        showSystemNoti('success',result.message);
    }
  }
}

</script>

<style scoped>
.h6 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
.plaque{
  justify-content: space-between;
  display: flex;
  border: 1px solid silver;
  border-radius: 4px;
  direction: ltr;
  text-align: center;
  height: 50px;
  margin-top: 5px;
}
.second
{
  width: 70%;
  border-right: 1px solid silver;
  border-left: 1px solid silver;
  display: flex;
  justify-content: space-between;
}
.first{
  width: 10%;
  font-size: 9px;
  text-align: left;
  background-color: #003399;
  color: white;
  line-height: 12px;
}
.third
{
  width: 20%;
}
.select-div
{
  width: 100%;
}
.p-input{
  width: 100%;
  height: 48px;
  border: none;
  font-size: 20px;
  text-align: center;
  padding: 0;
}
.select-div .form-control
{
  height: 48px;
  border-radius: 0!important;
  background: white;
  border: none;
}
.two_number_input{
  border: none;
  width: 100%;
  text-align: center;
}
.red
{
  background: #e0002c;
}
.green
{
  background: #009b49;
}
.white
{
  background: white;
}
.flag
{
  height: 8px;
  width: 100%;
}
</style>